
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FundCompareProductDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fundid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countrycode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languagecode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ProductDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fundid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fundid"}}},{"kind":"Argument","name":{"kind":"Name","value":"countrycode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countrycode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languagecode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languagecode"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fundname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fundincdt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shareclass"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shclname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prmryshclind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"investmentminimum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subseqinvestmentmin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shclcode"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"charges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expratgross"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expratnet"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"distribution"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incmdistrecorddate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incmdistamt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recdtnavval"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incmdistexdivdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exdivnavval"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"performance"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month_end"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asofdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avgannret1yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avgannret3yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avgannret5yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avgannret10yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avgannretactinc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calcnamestd"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aum"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asofdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totnetassets"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":894}};
    doc.loc.source = {"body":"query FundCompareProductDetails(\n  $fundid: String!\n  $countrycode: String!\n  $languagecode: String!\n) {\n  ProductDetails(\n    fundid: $fundid\n    countrycode: $countrycode\n    languagecode: $languagecode\n  ) {\n    fundid\n    fundname\n    fundincdt\n    shareclass {\n      shclname\n      prmryshclind\n      investmentminimum\n      subseqinvestmentmin\n      identifiers {\n        fundid\n        shclcode\n      }\n      charges {\n        expratgross\n        expratnet\n      }\n      distribution {\n        incmdistrecorddate\n        incmdistamt\n        recdtnavval\n        incmdistexdivdate\n        exdivnavval\n      }\n      performance {\n        month_end {\n          asofdate\n          avgannret1yr\n          avgannret3yr\n          avgannret5yr\n          avgannret10yr\n          avgannretactinc\n          calcnamestd\n        }\n      }\n    }\n    aum {\n      asofdate\n      totnetassets\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["FundCompareProductDetails"] = oneQuery(doc, "FundCompareProductDetails");
        
